import classNames from "classnames";
import React from "react";
import { twMerge } from "tailwind-merge";

const SelectInput = ({
  id,
  label,
  required,
  placeholder,
  error,
  options,
  className,
  isDisabled,
  containerClasses,
  ...rest
}) => {
  return (
    <div className={classNames(twMerge("mb-4", containerClasses))}>
      {label && (
        <label htmlFor={id} className="block mb-2 text-[0.9rem]">
          {label} {required && <sup className="text-red-500">*</sup>}
        </label>
      )}
      <select
        id={id}
        {...rest}
        disabled={isDisabled}
        className={classNames(
          twMerge(
            "w-full p-2 py-[0.55rem] border border-primary/30 focus:border-steelblue focus:text-steelblue rounded-md outline-none text-sm",
            className
          ),
          error && "border-red-500 focus:border-red-500",
          isDisabled && "cursor-not-allowed",
        )}
      >
        {placeholder && <option value="">{placeholder}</option>}
        {options && options.length > 0 ? (
          options.map((option, index) => (
            <option value={option.value} key={index}>
              {option.label}
            </option>
          ))
        ) : (
          <option value="" disabled>
            No data to select
          </option>
        )}
      </select>
      {error && (
        <small className="text-red-500 text-sm block my-1">{error}</small>
      )}
    </div>
  );
};

export default SelectInput;
